import { Colors } from '@robinpowered/design-system';
import { InfoSolid } from '@robinpowered/icons';
import SvgCircleCheckmarkSolid from '@robinpowered/icons/CircleCheckmarkSolid';
import moment from 'moment';
import { GetUserScheduleDeskReservations as Reservation } from '../../../contexts/UserSchedule/hooks/__generated__/useUserOfficeSchedule.generated';
import { getReservationInfo } from '../../../utilities/Reservation';

const getIconAndCopy = (reservation: Reservation) => {
  const { hasCheckIn, hasLocalCheckIn, checkInStatus } =
    getReservationInfo(reservation);
  const { checkInComplete, checkInRequiredFuture, checkInRequiredNow } =
    checkInStatus;

  if (!hasCheckIn) return null;

  const { icon, copy } = (() => {
    // LOCAL CHECK IN
    if (hasLocalCheckIn) {
      return {
        icon: 'WARN' as const,
        copy: 'Local check in required',
      };
    }
    // Just check in
    if (hasCheckIn) {
      if (checkInComplete) {
        return {
          icon: 'SUCCESS' as const,
          copy: 'Check in complete',
        };
      }
      if (checkInRequiredNow) {
        return {
          icon: 'WARN' as const,
          copy: `Check in required by ${moment(
            reservation.confirmation?.confirmationWindowEnd
          ).format('hh:mm A')}`,
        };
      }
      if (checkInRequiredFuture) {
        return {
          icon: 'WARN' as const,
          copy: `Check in starts at ${moment(
            reservation.confirmation?.confirmationWindowStart
          ).format('hh:mm A')}`,
        };
      }
    }

    return {
      icon: 'SUCCESS' as const,
      copy: '',
    };
  })();
  return {
    icon,
    copy,
  };
};

export const CheckInRequirementsIcon = (props: {
  reservation: Reservation;
}): JSX.Element | null => {
  const iconAndCopy = getIconAndCopy(props.reservation);
  const getIcon = () => {
    switch (iconAndCopy?.icon) {
      case 'SUCCESS':
        return (
          <SvgCircleCheckmarkSolid size={16} color={Colors.GreenProduct} />
        );
      case 'WARN':
        return <InfoSolid size={16} color={Colors.Gray60} />;
      default:
        return null;
    }
  };
  return getIcon();
};

export const CheckInRequirementsText = (res: Reservation) => {
  return getIconAndCopy(res)?.copy;
};
